import { ITrainingSet } from '../../types/interfaces/training-set';

export function mergeTrainingSetsForBulkUpdate(
  currentSets: ITrainingSet[] = [],
  updatedSets: ITrainingSet[] = [],
): ITrainingSet[] {
  if (!updatedSets.length) {
    return currentSets;
  }

  const updatedSetNumbers = new Set(updatedSets.map((set) => set.setNumber));
  const preservedSets = currentSets.filter(
    (set) => !updatedSetNumbers.has(set.setNumber),
  );

  return [...preservedSets, ...updatedSets].sort(
    (a, b) =>
      (a.setNumber ?? 0) - (b.setNumber ?? 0) ||
      (a.orderNumber ?? 0) - (b.orderNumber ?? 0),
  );
}
